import { ActionType } from '../../abacus/enums/action-type.enum'
import { InputType } from '../../abacus/enums/input-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceMode } from '../../abacus/enums/resource-mode.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const transparencyReportDefinition: ResourceDefinition = {
  title: 'Transparency Reports',
  nameSingular: 'transparency report',
  namePlural: 'transparency reports',
  className: 'TransparencyReport',
  mainIdentifier: 'reportingPeriodLabel',
  slug: 'transparency-reports',
  path: 'transparency-reports',
  icon: 'icon-list',
  hasDetailPage: true,
  hasListPage: true,
  buttons: [],
  defaultLink: LinkType.DETAIL,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Delete',
      permission: 'deleteTransparencyReports',
      action: (report) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: report,
          definition: transparencyReportDefinition
        }
      })
    }
  ],
  actionButtons: [
    {
      label: 'Publish',
      className: 'button is-success p-x-lg is-small',
      permission: 'reviewTransparencyReports',
      condition: (report) => report.status === 'pending_review',
      action: (report) => ({
        type: ActionType.Patch,
        patch: {
          path: `transparency-reports/${report.id}/status`,
          body: { status: 'published' },
          successMessage: 'The transparency report has been published',
          errorMessage: 'Error: Transparency report could not be published',
          redirectTo: `transparency-reports/${report.id}`
        }
      })
    },
    {
      label: 'Reject',
      className: 'button is-danger ml-2 p-x-lg is-small',
      permission: 'reviewTransparencyReports',
      condition: (report) => report.status === 'pending_review',
      action: (report) => ({
        type: ActionType.OpenCreateEditModal,
        openCreateEditModal: {
          title: `Reject the submission`,
          helpText: `You can provide a reason for rejecting the submission.`,
          definition: transparencyReportDefinition,
          mode: ResourceMode.Patch,
          item: report,
          patchURL: `transparency-reports/${report.id}/status`,
          fields: [
            {
              label: 'Rejection comment',
              property: 'rejectReason',
              placeholder: 'Explain why you are rejecting this submission.',
              className: 'is-12',
              inputType: InputType.Textarea
            },
            {
              label: 'Status',
              property: 'status',
              forcedValue: 'rejected',
              inputType: InputType.Select,
              hidden: true
            }
          ],
          flashMessageOnSuccess: 'The transparency report has been rejected',
          flashMessageOnError:
            'Error: Transparency report could not be rejected',
          redirectTo: `transparency-reports/${report.id}`
        }
      })
    }
  ]
}
